import { render, staticRenderFns } from "./CategoriasIndicadores.vue?vue&type=template&id=8f056200&"
import script from "./CategoriasIndicadores.vue?vue&type=script&lang=js&"
export * from "./CategoriasIndicadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports